import React, { Component } from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as tmxActions from '../Actions/tmxActions';
import TmxSelectionForm from "../Components/Tmx/TmxSelectionForm";
import { customerService } from "../Services/CustomerService.js";
import { withRouter } from 'react-router';

class TmxSelectionContainer extends Component {
	constructor(props){
		super(props);
		this.changeTmx=this.changeTmx.bind(this);
//		this.handleMorePriority=this.handleMorePriority.bind(this);
	}
	
	componentDidMount() {

	}
	
	changeTmx(idTmx){
		customerService.setTmx(this.props.customer.id, idTmx)
					.then(() => {return this.props.history.push('/customerForm/'+this.props.customer.id);})
					.catch(err => {/*console.log(err);*/});
	}
	
	//accessToken={this.props.user.access_token}
	render() {
//		console.log("[TmxSelectionContainer.render()] props: "+JSON.stringify(this.props));
	    return (<TmxSelectionForm	customer={this.props.customer}
									selectedId={parseInt(this.props.idCurentTmx)}
									tmxList={this.props.tmxList}
									changeTmx={this.changeTmx}/>);
	}
}

function mapStateToProps(state, ownProps) {  
//	console.log('mapStateToProps [TmxSelectionContainer]: '+JSON.stringify(ownProps));
	return {tmxList: state.tmxs.filter(tmx => {if(tmx.languagePair.id == ownProps.match.params.idLang){ return true;}}),
			customer: state.customers[ownProps.match.params.idCust],
			idCurentTmx: ownProps.match.params.idCurentTmx,
			user: state.user}
}

function mapDispatchToProps(dispatch) {  
	return {actions: bindActionCreators(tmxActions, dispatch)}
}

export default connect(mapStateToProps, mapDispatchToProps)(TmxSelectionContainer);  